import axiosInstance from '../../api/axiosInstance'

export interface CancelEnviaComRequest {
  carrier: string
  trackingNumber: string
  folio?: string
  ecommerce?: number
}

export interface CancelEnviaComResponse {
  success: boolean
  message: string
  data?: {
    meta: string
    data: Array<{
      carrier: string
      service: string
      trackingNumber: string
      ecommerce: number | null
    }>
  }
  cancelled_shipment?: {
    carrier: string
    trackingNumber: string
  }
  required_fields?: string[]
}

export const cancelarGuiaEnviaCom = async (requestData: CancelEnviaComRequest): Promise<CancelEnviaComResponse> => {
  const token = localStorage.getItem('accessToken')
  if (!token) {
    throw new Error('Error de autenticación')
  }

  // Validar campos requeridos
  if (!requestData.carrier || !requestData.trackingNumber) {
    throw new Error('Datos incompletos. Se requieren: carrier y trackingNumber')
  }

  // Validar carriers válidos
  const validCarriers = ['interRapidisimo', 'noventa9Minutos', 'deprisa', 'coordinadora', 'dhl', 'envia']
  if (!validCarriers.includes(requestData.carrier)) {
    throw new Error(`Carrier no válido. Carriers válidos: ${validCarriers.join(', ')}`)
  }

  console.log('🚫 Cancelando guía con Envia.com:', JSON.stringify(requestData, null, 2))

  const response = await axiosInstance.post('/envia-com/cancel', requestData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })

  return response.data
}
